import { render } from "./ReleaseNoteDetail.vue?vue&type=template&id=12df9381"
import script from "./ReleaseNoteDetail.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__